module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "leftClick",
    on: {
      "click": _vm.onClickLeft
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "../../../static/images/mobile/back.png"
    }
  })], 1), _vm._v(" "), _c('van-search', {
    attrs: {
      "autofocus": true,
      "show-action": "",
      "placeholder": "请输入课程名称"
    },
    on: {
      "search": _vm.get_search
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function() {
        return [_c('div', {
          on: {
            "click": _vm.get_search
          }
        }, [_vm._v("搜索")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.classNums),
      expression: "!classNums"
    }],
    staticClass: "history"
  }, [_c('p', {
    staticClass: "note"
  }, [_c('span', [_vm._v("最近搜索")]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "../../../static/images/mobile/remove.png"
    },
    on: {
      "click": _vm.empty
    }
  })], 1), _vm._v(" "), (_vm.historyList.length > 0) ? _c('ul', _vm._l((_vm.historyList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "historyLists"
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.goSearchDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('van-icon', {
      attrs: {
        "name": "../../../static/images/mobile/removex.png"
      },
      on: {
        "click": function($event) {
          return _vm.emptyone(index)
        }
      }
    })], 1)
  }), 0) : _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0 auto",
      "font-size": "16px",
      "margin-top": "20px"
    }
  }, [_vm._v("暂无搜索记录")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classNums),
      expression: "classNums"
    }],
    staticClass: "classNums"
  }, [_vm._v("\n\t\t\t共搜索到 "), _c('span', [_vm._v(_vm._s(_vm.classNum))]), _vm._v(" 门课\n\t\t")]), _vm._v(" "), _c('van-empty', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classNum == 0 ? true : false),
      expression: "classNum == 0 ? true : false"
    }],
    staticClass: "custom-image",
    attrs: {
      "image": "../../../static/images/mobile/examNum.png",
      "description": "暂无课程"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobile-hot"
  }, [_c('ul', _vm._l((_vm.list), function(list) {
    return _c('li', {
      key: list.id,
      on: {
        "click": function($event) {
          return _vm.goToGoodsDetails(list.id)
        }
      }
    }, [_c('div', {
      staticClass: "mobile-hot-img"
    }, [_c('img', {
      attrs: {
        "src": list.pictureUrl
      }
    })]), _vm._v(" "), _c('h5', {
      staticClass: "mobile-hot-title"
    }, [_vm._v("视频 |" + _vm._s(list.goodsName))]), _vm._v(" "), (list.categoryName) ? _c('span', {
      staticClass: "classify fl"
    }, [_vm._v(_vm._s(list.categoryName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "period"
    }, [_vm._v(_vm._s(list.testHours) + "学时 ")]), _vm._v(" "), _c('div', {
      staticClass: "classPrice fr",
      staticStyle: {
        "color": "#dc0021",
        "font-weight": "400"
      }
    }, [_vm._v("￥" + _vm._s(list.platformPrice))])])
  }), 0)]), _vm._v(" "), (_vm.courseCenter.length >= 1 ? true : false) ? _c('div', {
    staticClass: "classfooter"
  }, [_vm._v("已经到底了")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-501635be"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileSearchResult.vue
// module id = 1154
// module chunks = 41